import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { updateDisplayTimeListenerSaga } from './update-display-time';

export function* rootSaga(): SagaIterator {
    yield all([fork(updateDisplayTimeListenerSaga)]);
}
